import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const Chip = React.forwardRef(
  ({ className, title, icon, onClick, disabled, fringe, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={`app-chip ${
          disabled ? 'app-chip--disabled' : ''
        } ${className}`}
        onClick={disabled ? undefined : onClick}
        {...rest}
      >
        <div>{title}</div>
        {fringe}

        {icon}
      </div>
    );
  }
);

Chip.displayName = 'Chip';

Chip.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fringe: PropTypes.string.isRequired,
};

Chip.defaultProps = {
  className: '',
  icon: <></>,
  onClick: () => null,
  disabled: null,
};

export default Chip;
